var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u06A9\\u0627\\u0631\\u0628\\u0631\\u0627\\u0646",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H24V24H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M18,14a3,3,0,1,1,3-3A3,3,0,0,1,18,14ZM9,11a4,4,0,1,1,4-4A4,4,0,0,1,9,11Z",
    transform: "translate(0)",
    fill: "#8a8a8a",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M17.6,15c3.407.037,6.188,1.76,6.4,5.4a.51.51,0,0,1-.543.6H19.6A9.956,9.956,0,0,0,17.6,15ZM0,20.2C.388,15.427,4.262,13,8.983,13,13.771,13,17.7,15.293,18,20.2a.687.687,0,0,1-.751.8H.728A1.107,1.107,0,0,1,0,20.2Z",
    transform: "translate(0 0)",
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.50a9d3a4fe4efa0988804023aae74720.svg";
export { ForwardRef as ReactComponent };